import { prepareProfileFilter } from "@api/helpers/profileSearch";
import { UserProfile } from "@api/models/UserProfile";
import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";
import { UserRepository } from "@api/repositories/UserRepository";
import { getIgnoringQueryObject } from "@service/helpers/exclusionGroupHelper";
import { Store } from "vuex";

export class UserSelectService {
    constructor(private userRepository: UserRepository, private store: Store<any>, private groupFilter: any, private eventId: string, private userId: number)
    {}

    async getProfiles(keyword: string, force = false, filterOwnProfile = true): Promise<{ profiles: UserProfile[]; count: number } | undefined> {
        if (keyword.length >= 3 || force || keyword.length === 0) {

            const where = this.prepareCondition(keyword, filterOwnProfile);

            const query: QueryParametersInterface = {
                take: 5,
                where,
            }

            try {
                return await this.userRepository.profilesWithCount(query);
            }
            catch(e) {
                this.store.dispatch('reportException', e, { root: true });
            }
        }
    }

    private prepareCondition(searchStr: string, filterOwnProfile = true) {

        let result: any = {};

        result = prepareProfileFilter({
            searchStr: searchStr,
            excludingUsers: filterOwnProfile ? [this.userId] : [],
            groupFilter: this.groupFilter,
            eventId: this.eventId,
        }) || {};

        const ignoredUserGroupIds = this.store.getters['ignoredUserGroupIds'];

        if (ignoredUserGroupIds) {
            result.$and.push(getIgnoringQueryObject(ignoredUserGroupIds))
        }

        return result;

    }
}